export default
{
    name: 'app-text-lines-separated',

    props:
    {
        text: { type: String, default: '' },
        subClasses: { type: String, default: '' },
        underligned: { type: Boolean, default: false }
    },

    data()
    {
        return {
            textLinesSeparated: this._getTextLinesSeparated(this.text)
        }
    },

    methods:
    {
        _getTextLinesSeparated(text)
        {
            return text
                .replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, '<br />')
                .replace(/\n/g, '<br />')
                .split('<br />')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-text-lines-separated/script.js